import { Manager } from 'socket.io-client'

import { Message, VehicleStatusLog, VehicleStatusLogWebSocketEvent } from 'base/store/state.interface'
import { store } from '../store'
import { AuthenticationService } from './AuthenticationService'
import { EventService } from './EventService'
import { PullService } from './PullService'

export class SocketService {

  private manager: SocketIOClient.Manager
  private socket: SocketIOClient.Socket

  constructor() {
    let wsHost = `${window.location.origin}/socket.io`

    if (window.location.hostname === 'app.divera247.com' || window.location.hostname === 'app.divera247.de') {
      wsHost = `https://ws.divera247.com`
    }

    // this.manager = new Manager(window.location.protocol + '//' + window.location.hostname, {
    // this.manager = new Manager('https://ws.divera247.com', {
    this.manager = new Manager(wsHost, {
      reconnectionDelay: 2 * 1000,
      reconnectionDelayMax: 60 * 1000,
      randomizationFactor: 0.7
    })
  }

  connect() {
    if (this.socket) this.socket.disconnect()

    this.socket = this.manager.socket('/')
    this.initEvents()
  }

  reconnect() {
    this.connect() // Connect already force a disconnection
  }

  disconnect() {
    if (!this.socket) {
      console.info('Socket | Cannot disconnect from socket, as none is available')
      return
    }

    this.socket.disconnect()
  }

  private initEvents() {
    if (!this.socket) {
      console.info('Socket | Cannot init socket events, as none is available')
      return
    }

    this.socket.on('connect', () => {
      console.info('Socket | Socket connected succesfully')

      const jwt = AuthenticationService.jsonWebToken
      if (!jwt) {
        console.error('Socket | No valid json web token available to authenticate in socket')
        return
      }

      console.info('Socket | Authenticate to socket with jwt ')
      this.socket.emit('authenticate', { jwt })
    })

    this.socket.on('init', () => {
      console.info('Socket | Initialized socket, successfully authenticated')
    })

    this.socket.on('subscribed', () => {
      console.info('Socket | Subscribed to socket')
    })

    // Handle connection errors
    this.socket.on('connect_error', (error: Error) => {
      console.error('Socket | Error connecting to sock4et', { error })
    })

    this.socket.on('connect_timeout', () => {
      console.info('Socket | Connection to socket timed out')
    })

    this.socket.on('reconnecting', (attempt: number) => {
      console.info(`Socket | Attempt number ${attempt} to reconnect socket`)
    })

    this.socket.on('reconnect_error', (error: Error) => {
      console.error('Socket | Failed to reconnect to socket', { error })
    })

    this.socket.on('reconnect_failed', () => {
      console.error('Socket | Failed to reconnect to socket: maximum number of reconnect attempts reached')
    })

    this.socket.on('reconnect', () => {
      console.info('Socket | Successfully reconnected to socket')
    })

    // Push to pull
    this.socket.on('cluster-pull', async (data: { pull: object}) => {
      if (!data.pull) return
      await this.pull(data.pull)
    })

    // Messenger
    this.socket.on('cluster-message', async (data: { message: Message }) => {
      if (!data.message) return
      await this.onMessageReceived(data.message)
    })

    this.socket.on('user-message', async (data: { message: Message }) => {
      if (!data.message) return
      await this.onMessageReceived(data.message)
    })

    // Vehicle Status
    this.socket.on('cluster-vehicle', async (data: { vehicle: VehicleStatusLogWebSocketEvent }) => {
      const rawVehicle = data.vehicle

      if (!rawVehicle) return

      // convert to VehicleStatusLog
      const vehicleForVehicleStatusHistory: VehicleStatusLog = {
        id: rawVehicle.id,
        status_id: rawVehicle.fmsstatus_id,
        status_note: rawVehicle.fmsstatus_note,
        ts: rawVehicle.fmsstatus_ts
      }

      void store.dispatch('setVehicleStatus', rawVehicle)
      void store.dispatch('setVehicleStatusHistory', vehicleForVehicleStatusHistory)
      EventService.$emit('socketservice--vehicle-status-received', vehicleForVehicleStatusHistory)
    })

    // User Status
    this.socket.on('user-status', async (data: any) => {
      const rawStatus = data.status

      if (!rawStatus) return

      void store.dispatch('setStatusState', rawStatus)
    })

    this.socket.on('cluster-monitor', async (data: any) => {
      const rawMonitor = data.monitor

      if (!rawMonitor) return

      await store.dispatch('setMonitorState', rawMonitor)
    })
  }

  protected async onMessageReceived(message: Message) {
    await store.dispatch('processMessage', { message: message, isSocketEvent: true })

    EventService.$emit('socketservice--message-received', message)
  }

  private async pull(param: any) {
    void PullService.pull()
  }

}
